import { render, staticRenderFns } from "./delivery-tab.vue?vue&type=template&id=90f8c238&"
import script from "./delivery-tab.vue?vue&type=script&lang=js&"
export * from "./delivery-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports